export default function AttachFindingDocumentController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  amDataService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Document Added';
  vm.isExpanded = false;
  vm.loading = false;
  vm.canDownloadDocument = userService.getUserPermission('displayDOCDownloadDocumentLink');
  vm.canEditDocument = userService.getUserPermission('displayDOCEditDocumentLink');
  vm.canDeleteDocument = userService.getUserPermission('displayDOCDeleteDocumentLink');

  // Attach Event Handlers
  vm.handleAttachDocument = _handleAttachDocument;

  function _handleAttachDocument() {
    const dfdSave = $q.defer();

    if (vm.document.attached) {
      amDataService.attachFindingDocument(vm.findingId, vm.document.documentId, vm.document.name).then(response => {
        if (!response.data) {
          alerts.error('Error occurred while attaching the Document.');
          dfdSave.reject();
        } else {
          alerts.success(`Document ${vm.document.name} has been attached successfully.`);
          vm.document.findingDocumentId = response.data.findingDocumentId;
          $rootScope.$broadcast('refreshAMFindingDocuments', { findingId: vm.findingId });
          // ssDialogService.hide(ssDialogService.dialog.auditTrail.editFindingCommentDialog);
          dfdSave.resolve();
        }
      });
    } else {
      amDataService.detachFindingDocument(vm.document.findingDocumentId).then((response) => {
        if (!response.status === 200) {
          alerts.error('Error occurred while detaching the Document.');
          dfdSave.reject();
        } else {
          alerts.success(`Document ${vm.document.name} has been detached successfully.`);
          vm.document.findingDocumentId = null;
          $rootScope.$broadcast('refreshAMFindingDocuments', { findingId: vm.findingId });
          // ssDialogService.hide(ssDialogService.dialog.auditTrail.editFindingCommentDialog);
          dfdSave.resolve();
        }
      });
    }
  }
}

AttachFindingDocumentController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'amDataService'
];
